// extracted by mini-css-extract-plugin
export var actionText = "_s0-4";
export var container = "_s0-0";
export var leftSection = "_s0-1";
export var rightSection = "_s0-2";
export var settingsButton = "_s0-6";
export var settingsIcon = "_s0-7";
export var shortcut = "_s0-5";
export var shortcutGroup = "_s0-3";